export enum PermissionLevel {
    None   = 0,      // 0
    Read   = 1 << 0, // 1
    Update = 1 << 1, // 2
    Create = 1 << 2, // 4
    Delete = 1 << 3, // 8
}
